// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2tg2W","description":"PatientConsentPreview_description__FIZ_p"};